import { h } from 'preact';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MetaRouter } from '../../utils/metarouter';

import { buildMediaQuery, breakpoints } from '../../utils/media-queries';

const FilterBar = ({ options, selected, onChange, ...props }) => {
    return (
        <Container {...props}>
            {options.map((o) => (
                <Button
                    key={o.id}
                    selected={o.id === selected}
                    data-age-range={o.value}
                    onClick={(e) => {
                        e.preventDefault();
                        onChange(o.id);
                        e.isTrusted && sendTrackEvent(o.value);
                    }}>
                    {o.label}
                </Button>
            ))}
        </Container>
    );
};

FilterBar.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            label: PropTypes.string,
            order: PropTypes.arrayOf(PropTypes.number),
        }),
    ),
    selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
};

FilterBar.defaultProps = {
    options: [],
    selected: '',
    onChange: () => {},
};

const Container = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
`;

const Button = styled.button.attrs((p) => ({
    className: `super-col__filter button button--sm ${
        !p.selected ? 'button--secondary' : ''
    }`,
}))`
    &.super-col__filter.button {
        font-weight: 600;

        @media ${buildMediaQuery(breakpoints.lg)} {
             {
                font-size: 16px;
            }
        }
    }
`;

const sendTrackEvent = (age) => {
    MetaRouter.sendTrackEvent('age_range_selected', {
        age_range: age || '',
        screen_name: 'home_page',
        funnel_name: 'regular',
    });
};

export default FilterBar;
